import { render, staticRenderFns } from "./InventoryCompareModal.vue?vue&type=template&id=2810d48f&scoped=true"
import script from "./InventoryCompareModal.vue?vue&type=script&lang=js"
export * from "./InventoryCompareModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryCompareModal.vue?vue&type=style&index=0&id=2810d48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810d48f",
  null
  
)

export default component.exports